import { Star, Facebook } from "lucide-react";
import { BUSINESS } from "@/lib/business";

const REVIEWS = [
  {
    name: "Paul Bilton",
    date: "17 Sept 2025",
    quote:
      "Professional, friendly and punctual. Would I recommend Optima Electrical Ltd, 100%. Would I use anyone else, absolutely not. I can't recommend any higher.",
  },
  {
    name: "Kyle Beale",
    date: "16 Sept 2025",
    quote:
      "Top quality work, friendly and professional. Wouldn't use another Sparky. Highly recommend.",
  },
  {
    name: "Brenan Crosby",
    date: "5 Sept 2025",
    quote:
      "Ernest from Optima was really helpful when he attended to upgrade my consumer unit. He was very thorough and explained every process. Really neat and tidy!",
  },
  {
    name: "Lorna Roots",
    date: "14 Aug 2025",
    quote:
      "Would highly recommend — had new heaters installed by Ernest, very efficient, very friendly, nothing was too much. Very happy and will certainly be calling if I need any more electrical work done. Thank you so much.",
  },
  {
    name: "Mandy Llewellyn",
    date: "29 Sept 2025",
    quote:
      "Had 2 lights changed over and a dimmer switch fitted. Very friendly guy, tried to keep his mess to a minimum but cleaned up after himself when he was done in each room. Would highly recommend him.",
  },
  {
    name: "Briony Fawsett",
    date: "7 Oct 2025",
    quote:
      "Would definitely recommend — amazing service, very friendly, professional and efficient, done a great job while keeping everything tidy.",
  },
  {
    name: "Julian Laurentius",
    date: "10 Dec 2025",
    quote:
      "We're very pleased with the service provided by Optima Electrical Solutions. The team was professional, knowledgeable, and offered expert advice throughout the project. The electrical work was carried out to a high standard.",
  },
  {
    name: "Emma Rose",
    date: "22 Dec 2025",
    quote:
      "Great work from Ernest who was friendly, quick and considerate about clearing up any mess after him. Would definitely recommend and will remember you for any future electrical work. Thank you.",
  },
  {
    name: "Tanya Tsankova",
    date: "29 Apr",
    quote:
      "Highly recommend Optima Electrical — fantastic job by Ernest who fitted our chandelier and we couldn't be happier with the result! Very reliable and professional. We will definitely be using Optima Electrical again!",
  },
];

export const Testimonials = () => (
  <section
    id="reviews"
    data-testid="testimonials-section"
    className="relative bg-[#0F0F0F] py-28 lg:py-36"
  >
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-16">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <span className="text-[11px] font-bold uppercase tracking-[0.3em] text-[#1E90FF]">
              03 — Reviews
            </span>
            <span className="h-px w-12 bg-[#1E90FF]/40" />
          </div>
          <h2
            className="text-4xl sm:text-5xl lg:text-6xl text-white font-semibold leading-[1.05] tracking-tight max-w-3xl"
            style={{ fontFamily: "Outfit" }}
          >
            100% recommend
            <br />
            <span className="text-[#A0AAB2] italic font-light">on Facebook.</span>
          </h2>
          <div className="mt-6 flex items-center gap-4">
            <div className="flex gap-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-5 h-5 fill-[#1E90FF] text-[#1E90FF]" strokeWidth={0} />
              ))}
            </div>
            <span className="text-[#A0AAB2] text-sm">
              <span className="text-white font-medium">19 reviews</span> · 100% recommend rate
            </span>
          </div>
        </div>

        <a
          href={BUSINESS.facebook}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="facebook-link-reviews"
          className="inline-flex items-center gap-2 text-sm text-[#A0AAB2] hover:text-[#1E90FF] transition-colors"
        >
          <Facebook className="w-4 h-4" /> Read all reviews on Facebook
        </a>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5">
        {REVIEWS.map((r, i) => (
          <div
            key={r.name}
            data-testid={`review-${i}`}
            className="bg-[#0A0A0A] p-8 lg:p-10 group hover:bg-[#121212] transition-all duration-300 flex flex-col"
          >
            <div className="flex gap-1 mb-6">
              {[...Array(5)].map((_, idx) => (
                <Star
                  key={idx}
                  className="w-4 h-4 fill-[#1E90FF] text-[#1E90FF]"
                  strokeWidth={0}
                />
              ))}
            </div>
            <p className="text-white/85 leading-relaxed text-base flex-1">
              "{r.quote}"
            </p>
            <div className="mt-8 pt-6 border-t border-white/5 flex items-center justify-between">
              <div>
                <div className="text-white font-medium text-sm" style={{ fontFamily: "Outfit" }}>
                  {r.name}
                </div>
                <div className="text-[#A0AAB2] text-xs mt-0.5">{r.date}</div>
              </div>
              <Facebook className="w-4 h-4 text-[#1E90FF]/60" />
            </div>
          </div>
        ))}
      </div>

      <div className="mt-10 text-center text-xs text-[#A0AAB2]/70 tracking-wide">
        All reviews verified from our Facebook page · facebook.com/Optima Electrical Solutions Ltd
      </div>
    </div>
  </section>
);
